<template>
  <ul class="nav nav-mobile-menu">
    <drop-down>
      <template slot="title">
        <i class="nc-icon nc-bullet-list-67"></i>
      </template>
      <a @click="logout" href="javascript:;" class="dropdown-item text-danger">
        <i class="nc-icon nc-button-power"></i> Cerrar sesión
      </a>
    </drop-down>
  </ul>
</template>
<script>
  import DropDown from 'src/components/Dropdown.vue'

  export default {
    components: {
      DropDown
    },
    methods: {
      logout() {
        localStorage.removeItem('jwt');
        localStorage.removeItem('user');
        this.$router.push({ path: "/login" })
      }
    }
  }
</script>
<style>
</style>
